/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const CooledSeats = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 24 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M20.47 18.79c-2.41.25-7.86 1.39-10.81 2v-.09c2-4.47-1.52-9.72-3.23-12.24a11.86 11.86 0 0 1-.73-1.15 3.79 3.79 0 0 0-2-2.21.63.63 0 0 1 0-.76.46.46 0 0 0 .2-.19A1.22 1.22 0 0 0 4 3.8C4.17 3.32 2.79 1 2.79 1A2 2 0 0 0 .35.7c-.3.38 1.83 6.79 1.83 6.79L5 19.88a2.1 2.1 0 0 0-.2 1.57l1.23 3.83a.43.43 0 0 0 .41.3h15a.43.43 0 0 0 .41-.29l.86-2.58v-.06c.2-.54.82-2.17.05-3.16a2.47 2.47 0 0 0-2.29-.7zM17.2 12.5c.32 2 4.54-1 3.95-3a3.8 3.8 0 0 0-1.7-2A2.07 2.07 0 0 1 17.9 9v.37c.1 1.05-.9 2.11-.7 3.13zM15.48 6.39A2.07 2.07 0 0 1 17 4.93c0-.13 0-.25-.05-.37-.05-1.07.91-2.14.75-3.15-.32-2-4.54 1-4 3a3.8 3.8 0 0 0 1.78 1.98zM20 3.27A3.8 3.8 0 0 0 18 5a2.07 2.07 0 0 1 1.46 1.55h.37c1.07-.06 2.13.9 3.15.74C25 6.9 22 2.68 20 3.27z" /><circle cx="17.46" cy="6.95" r="1.26" /><path d="M14.91 10.64a3.8 3.8 0 0 0 2-1.7 2.07 2.07 0 0 1-1.46-1.55h-.37c-1.07.06-2.14-.9-3.15-.74-2.04.35 1 4.58 2.98 3.99z" /></g>
      </g>
    </svg>
  </span>
);

CooledSeats.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

CooledSeats.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default CooledSeats;
